// ⬡B:aba_shared.ccwa_core.backgrounds:CONST:imgur_canonical_set:20260503⬡
// Brandon's canonical background image set, hosted on his Imgur CDN.
// Pulled from past chats Jan 31 + Feb 1 2026 visual identity guide v3.2.
// Used across CCWA, MyABA CIP, OneABA CIB, GMG-U, Collective Retreat — single
// source of truth so a swap in one place propagates everywhere (F5 Triplet Rule).

export const BACKGROUNDS = [
  { id: 'black-landscape', name: 'Black Landscape', url: 'https://i.imgur.com/ZwVdgzN.jpeg', mood: 'serene' },
  { id: 'nebula',          name: 'Nebula',          url: 'https://i.imgur.com/nLBRQ82.jpeg', mood: 'cosmic' },
  { id: 'storm-clouds',    name: 'Storm Clouds',    url: 'https://i.imgur.com/RRKjvgR.jpeg', mood: 'dramatic' },
  { id: 'glass-windows',   name: 'Glass Windows',   url: 'https://i.imgur.com/Kjjs7nt.jpeg', mood: 'sophisticated' },
  { id: 'motion',          name: 'Motion',          url: 'https://i.imgur.com/3hG18cp.jpeg', mood: 'dynamic' },
  { id: 'mountain-snow',   name: 'Mountain Snow',   url: 'https://i.imgur.com/7Ffjcy2.png',  mood: 'peaceful' },
  { id: 'particle-lights', name: 'Particle Lights', url: 'https://i.imgur.com/wLi9sGD.jpeg', mood: 'ethereal' },
  { id: 'wet-city',        name: 'Wet City',        url: 'https://i.imgur.com/h8zNCw1.jpeg', mood: 'cinematic' },
  { id: 'beach',           name: 'Beach',           url: 'https://i.imgur.com/YaH4lbp.jpeg', mood: 'relaxed' },
  { id: 'embers',          name: 'Embers',          url: 'https://i.imgur.com/9HZYnlX.png',  mood: 'warm' },
  { id: 'pink-smoke',      name: 'Pink Smoke',      url: 'https://i.imgur.com/3RkebB2.jpeg', mood: 'dreamy' },
  { id: 'unity',           name: 'Unity',           url: 'https://i.imgur.com/IJAeq7t.png',  mood: 'inspiring' },
  { id: 'three-goats',     name: '3 GOATS',         url: 'https://i.imgur.com/jNJUq4u.png',  mood: 'inspiring' },
];

export const BG_URLS = BACKGROUNDS.map(b => b.url);

// Brand assets used by SignInScreen, ChatPanel header, etc.
export const BRAND = {
  GMG_LOGO: 'https://i.imgur.com/qslzgTU.png',
  ABA_LOGO_STATIC: 'https://i.imgur.com/0be7HCF.png',
  ENVOLVE_LOGO: 'https://i.imgur.com/I2F4EWs.png',
};

// Pick a background by day-of-month for daily rotation
export function pickDailyBg() {
  const day = new Date().getDate();
  return BG_URLS[day % BG_URLS.length];
}

// Pick by name (Brandon: "show me wet city")
export function pickBgByName(name) {
  const found = BACKGROUNDS.find(b => b.id === name || b.name.toLowerCase() === name.toLowerCase());
  return found?.url || pickDailyBg();
}
